/*
*   路口配时组件
*   zxw
*   2024-05-21
*/

import React , { Component, useState, useEffect } from 'react';
import * as ReactDOM from 'react-dom/client';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import { Row, Col, message, Table, Tag, Select, 
    Modal, Button, Dropdown, Upload, Input } from 'antd';
import { DownOutlined, PlusOutlined, 
    ExportOutlined, ImportOutlined,
    ExclamationCircleFilled } from '@ant-design/icons';
import { UjoinParams, AddRequestHeaders, UdateFormat, 
    winWidth } from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import Entity from './TimingEntity.js';
import TimingArchive from './TimingArchive.js';

const Option = Select.Option;
const { TextArea } = Input;
const MODULENAME = '路口配时';

var root = null;

/**
 * 信息提示框组件
 * @param {*} props 
 * @returns 
 */
const InfoPromptModal = (props) => {
    const [open, setOpen] = useState(false);
    const [description, setDescription] = useState('');

    useEffect(()=>{
        setOpen(props.open);
    }, [props]);

    /**
     * 取消
     */
    const handleCancel = () =>{
        setDescription('');
        setOpen(false);
    }

    /**
     *  处理
     *  @param {*} record 
     *  @param {*} action 
     */
   const handleOK = () =>{
        $.ajax({
            url: `${CNF.api}intersection/timings/${props.record.key}`,
            headers: AddRequestHeaders(),
            type: props.action==='DELETE'?'DELETE':'PUT',
            dataType: 'JSON',
            data:JSON.stringify({
                'action': props.action,
                'description': description
            }),success:function(data){
                if(data.res === 0){
                    message.success(data.msg, 1);
                    setTimeout(function(){
                        props.isRefresh();
                    }, 1500);
                }else{
                    message.error(data.msg, 1);
                }
                handleCancel();
            }
        })
    }

    return (
        <>
            <Modal
                okType='danger'
                title={<><ExclamationCircleFilled style={{ color: '#FAAD13' }} /> {MODULENAME}</>}
                closeIcon={false}
                open={open}
                onOk={()=>{handleOK()}}
                onCancel={()=>{handleCancel()}}
                okText='确认'
                cancelText='取消'
                okButtonProps={{disabled: description?false:true}}
            >
                <div>
                    <p style={{ marginTop: 0 }}>考虑清楚了？确定要{props.action==='DISABLE'?'禁用':props.action==='ACTIVE'?'激活':'删除'}该{MODULENAME}：{props.record.intersection_name}</p>
                    <TextArea
                        placeholder='必填字段，需要备注说明'
                        autoSize={{ minRows: 3, maxRows: 5 }}
                        onChange={(e)=>{setDescription(e.target.value)}}
                        value={description}
                    />
                </div>
            </Modal>
        </>
    );
}

class Lists extends Component{
    constructor(props){
        super(props);
        this.state = {
            dataLists: this.props.dataLists,
        }
    }

    update = (record) =>{this.props.setIsModalOpen(true, record);}
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.dataLists !== nextProps.dataLists) {
            this.setState({
                dataLists: nextProps.dataLists,
            })
        }
    }

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    operation = (action, record) => {
        switch(action){
            case 'update':
                this.update(record);
                break;
            case 'archive':
                this.archive(record);
                break;
            case 'disable':
                this.showInfoPromptModal(record,'DISABLE');
                break;
            case 'active':
                this.showInfoPromptModal(record,'ACTIVE');
                break;
            case 'delete':
                this.showInfoPromptModal(record,'DELETE');
                break;
            default:
                break;
        }
    }

    /**
     * 显示提示框信息信息
     * @param {*} record 
     */
    showInfoPromptModal = (record, action) =>{
        if(!root){
            root = ReactDOM.createRoot(document.getElementById('info-prompt-modal-id'));
        }
        root.render(
            <InfoPromptModal
                open={true}
                isRefresh={this.props.isRefresh}
                action={action}
                record={record}
            />
        );
    }

    archive = (record) =>{
        if(!root){
            root = ReactDOM.createRoot(document.getElementById('timing-archive-id'));
        }
        root.render(
            <TimingArchive
                open={true}
                record={record}
            />);
    }

    render(){
        const columns = [
            {title: '',width: 20,dataIndex: '',key: 'key',fixed: 'left',},
            {title: '路口名称',dataIndex: 'intersection_name',key: 'intersection_name',},
            {title: '时段',dataIndex: 'time_period',key: 'time_period',},
            {title: '方向',dataIndex: 'direction',key: 'direction',},
            {title: '星期',key: 'week',
                render: (record) => {
                    return <>
                        {
                            record.week && record.week.length>0 && record.week.map((item) => {
                                switch(item){
                                    case '1':
                                        return <Tag key={item} color='blue'>星期一</Tag>
                                    case '2':
                                        return <Tag key={item} color='blue'>星期二</Tag>
                                    case '3':
                                        return <Tag key={item} color='blue'>星期三</Tag>
                                    case '4':
                                        return <Tag key={item} color='blue'>星期四</Tag>
                                    case '5':
                                        return <Tag key={item} color='blue'>星期五</Tag>
                                    case '6':
                                        return <Tag key={item} color='cyan'>星期六</Tag>
                                    case '0':
                                        return <Tag key={item} color='cyan'>星期日</Tag>
                                    default:
                                        return ''
                                }
                            })
                        }
                    </>
                }
            },
            {title: '时长(s)',key: 'duration',
                render: (record) => {
                    if(parseInt(record.duration) === 0){
                        return <Tag color='gold'>黄闪</Tag>
                    }else if(parseInt(record.duration) === -1){
                        return <Tag color='green'>常绿</Tag>
                    }else if(parseInt(record.duration) === -2){
                        return <Tag color='red'>关闭</Tag>
                    }else{
                        return <span>{record.duration}</span>
                    }
                }
            },
            {title: '创建时间', dataIndex: 'create_time', key: 'create_time',width: 120,},
            {title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: 100,},
            {title: '状态', key: 'status', fixed: 'right',width: 80,
                render: function(record){
                    for(let item of CNF.status){
                        if(parseInt(record.status) === parseInt(item.value)){
                            return item.key
                        }
                    }
                }
            },
            {title: '', key: 'operation', fixed: 'right', width: 80,
                render: (record) => {
                    let items = [];
                    if(this.props.btnLists.indexOf('btn_teii_intersection_timing_update')>0){
                        items.push({key: '1', label: (<Button style={{ height: 10,paddingTop:0 }} type='link' onClick={()=>{this.operation('update', record)}}>修改</Button>)})
                    }
                    //  配时档案
                    if(this.props.btnLists.indexOf('btn_teii_intersection_timing_archive')>0){
                        items.push({key: '2', label: (<Button style={{ height: 10,paddingTop:0 }} type='link' onClick={()=>{this.operation('archive', record)}}>档案</Button>)})
                    }
                    if(this.props.btnLists.indexOf('btn_teii_intersection_timing_update') >= 0 
                    && record.status.toString() === CNF.status[0].value.toString()){
                        items.push({key: '3', label: (<Button style={{ height: 10,paddingTop:0 }} type='link' onClick={()=>{this.operation('disable', record)}}>禁用</Button>)})
                    }
                    if(this.props.btnLists.indexOf('btn_teii_intersection_timing_update') >= 0 
                    && record.status.toString() === CNF.status[1].value.toString()){
                        items.push({key: '4', label: (<Button style={{ height: 10,paddingTop:0 }} type='link' onClick={()=>{this.operation('active', record)}}>激活</Button>)})
                    }
                    if(this.props.btnLists.indexOf('btn_teii_intersection_timing_delete')>=0){
                        items.push({key: '5', label: (<Button style={{ height: 10,paddingTop:0 }} type='link' onClick={()=>{this.operation('delete', record)}}>删除</Button>)})
                    }
                    return (
                        <Dropdown menu={{ items, }}>
                            <Button type='link' style={{ padding:0, height: 10,margin:0 }}>
                                    操作
                                    <DownOutlined />
                            </Button>
                        </Dropdown>
                    );
                }
            }
        ];
        return(
            <div>
                <Table 
                    columns={columns} 
                    className='content-table-row'
                    size='middle'
                    dataSource={this.state.dataLists} 
                    // scroll={{ x: winWidth}} 
                    pagination={{
                        showSizeChanger: false,
                        // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                        showQuickJumper: false,
                        showTotal: () => `共${this.props.pageCount}条`,
                        pageSize: winWidth>1440?CNF.pageSize:CNF.pageSize-2,
                        current: this.props.currentIndex,
                        total: this.props.pageCount,
                        onShowSizeChange: (current,pageSize) => this.props.changePageSize(pageSize,current),
                        onChange: (current) => this.props.changeIndex(current),
                    }}
                />
            </div>
        );
    }
}

class CPT extends Component{
    constructor(props){
        super(props);
        this.state = {
            record: null,
            isModalOpen: false,
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            intersectionUlid: '',
            timePeriod: '',
            direction: '',
            status: 1,
            intersectionDDList: []
        }
    }

    isRefresh = () =>{this.setState({isRefresh: this.state.isRefresh===1 ? 0:1});}
    search = () => {this.setState({currentIndex: 1});this.isRefresh();}
    changeIntersectionUlid = (value, option) =>{this.setState({ intersectionUlid: value});this.search();}
    changeTimePeriod = (e) =>{this.setState({timePeriod: e.target.value});this.search();}
    changeDirection = (e) =>{this.setState({direction: e.target.value});this.search();}
    changeStatus = (value) =>{ this.setState({ status: value});this.search();}
    changeIndex = (index) =>{this.setState({currentIndex: index});this.isRefresh();}

    setIsModalOpen = (value, record) =>{this.setState({isModalOpen: value, record: record});}
    create = () =>{this.setIsModalOpen(true, null);}

    /***
     * 获取路口下拉列表
     */
    intersectionDDList(){
        const _this = this;
        const params = {
            'rss': 'list',
            'page_size': CNF.pageSize * 100,
            'current_index': 1
        };
        $.ajax({
            url: `${CNF.api}intersections${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            crossDomain: true,
            type: 'GET',success:function(data){
                if(data.res === 0){
                    _this.setState({ intersectionDDList: data.dat});
                }else{
                    message.error(data.msg);
                }
            }
        })
    }

    /**
     * 获取列表
     */
    getLists(){
        const _this = this;
        const params = {
            'intersection_ulid': this.state.intersectionUlid,
            'time_period': this.state.timePeriod,
            'direction': this.state.direction,
            'status': this.state.status,
            'page_size': winWidth>1440?CNF.pageSize:CNF.pageSize-2,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}intersection/timings${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    if(data.dat.length > 0){
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt
                        });
                    }else{
                        _this.setState({
                            dataLists: [],
                            pageCount: 0
                        });
                    }
                }else{
                    message.error(data.msg, 1.5);
                }
            }
        })
    }

    /**
     * 导入前检查
     * @param {*} info 
     * @returns 
     */
    uploadCheck = (info) =>{
        if (info.size > 10240000){
            message.error('上传文件超过10M，建议拆分文件！', 1);
            return false
        }
        if (info.name.match(/.xls[x]{0,1}/) === null){
            message.error('文件格式不对，只支持 xls 或 xlsx ！', 1);
            return false
        }
        return true
    }

    /**
     * 执行导入
     * @param {*} info 
     */
    upload = (info) =>{
        const _this = this;
        if (info.file.status === 'uploading') {
            message.loading({content: '文件正在导入...',key:'import', duration: 0});
        } else if (info.file.status === 'done') {
            message.success({content: '文件导入完成！',key:'import', duration: 1.5});
            if(info.file.response.dat){
                setTimeout(function(){
                    Modal.success({
                        title: '导入' + MODULENAME,
                        width: 500,
                        content: (
                            <div style={{ height:'300px', overflow:'scroll' }}>
                                <Row style={{ lineHeight: 2 }} key={0}>
                                    <Col span={3}>行号</Col>
                                    <Col span={12}>路口名称</Col>
                                    <Col span={9}>消息说明</Col>
                                </Row>
                                {
                                    info.file.response.dat.length &&
                                    info.file.response.dat.map((item) =>{
                                        return(
                                            <Row style={{ lineHeight: 2 }} key={item['key']}>
                                                <Col span={3}>{item['key']}</Col>
                                                <Col span={9}>{item['name']}</Col>
                                                <Col span={12}>{item['msg']}</Col>
                                            </Row>
                                        )
                                    })
                                }
                            </div>
                        ),
                        onOk() {_this.isRefresh();},
                    });
                },2000)
            }else{
                message.error(info.file.response.msg);
            }
        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} 导入失败！`);
        }
    }

    /***
    * 导出 Excel
    */
    export = (data) =>{
        var date = new Date(); 
        let option = {};  //    option代表的就是excel文件
        option.fileName = '路口配时明细-' + UdateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '路口配时明细',  //  excel文件中sheet页名称
                sheetHeader: [
                    '路口名称', 
                    '星期', 
                    '时段',
                    '方向',
                    '时长(s)'],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 获取导出明细
     */
     exportObtain(e){
        if(e.target.nodeName !== 'svg'){ return; }
        const _this = this
        const params = {
            'intersection_ulid': this.state.intersectionUlid,
            'time_period': this.state.timePeriod,
            'direction': this.state.direction,
            'status': this.state.status,
            'page_size': 65535,
            'current_index': 1
        }
        $.ajax({
            url: `${CNF.api}intersection/timings${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    if(data.dat.length > 0){
                        //  删除非必须字段
                        var d = [];
                        for(let i=0;i<data.dat.length;i++){
                            var item = data.dat[i]
                            delete item['key'];
                            delete item['status'];
                            delete item['intersection_ulid'];
                            delete item['create_username']
                            delete item['create_displayname']
                            delete item['create_time']
                            delete item['update_time']
                            //  JSON转数组字符串
                            item['week'] = JSON.stringify(item['week']);
                            d.push(item);
                        }
                        _this.export(d);
                    }else{
                        _this.export([]);
                    }
                }else{
                    message.error(data.msg);
                }
            }
        })
    }

    componentDidUpdate(){
        if(this.state.init !== this.state.isRefresh){
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount(){
        this.intersectionDDList();
        this.getLists();
    }

    render(){
        return(
            <>
                <div>
                    <Row style={{ height: 60, paddingTop:10, paddingLeft:20}}>
                        <Col span={4} style={{ marginLeft: 5 }}>
                            <Select 
                                showSearch
                                value={this.state.intersectionUlid}
                                style={{ width: '100%' }} 
                                onChange={this.changeIntersectionUlid}
                                disabled={this.state.loading}
                                filterOption={(input, option) =>
                                    option.props.children.indexOf(input) >= 0
                                }
                            >
                                <Option value=''>请选择路口</Option>
                                {
                                    this.state.intersectionDDList.length && this.state.intersectionDDList.map((item) => {
                                        return <Option key={item['key']} value={item['key']}>{item['name']}</Option>
                                    })
                                }
                            </Select>
                        </Col>
                        <Col span={2} style={{ marginLeft: 5 }}>
                            <Input
                                onChange={this.changeTimePeriod}
                                onPressEnter={this.search}
                                placeholder='时段...'
                                value={this.state.timePeriod}
                            />
                        </Col>
                        <Col span={2} style={{ marginLeft: 5 }}>
                            <Input
                                onChange={this.changeDirection}
                                onPressEnter={this.search}
                                placeholder='方向...'
                                value={this.state.direction}
                            />
                        </Col>
                        <Col span={2} style={{ marginLeft: 5 }}>
                            <Select 
                                value={this.state.status}
                                style={{ width: '100%' }} 
                                onChange={this.changeStatus}
                            >
                                <Option value=''>状态</Option>
                                {
                                    CNF.status && CNF.status.map((item) => {
                                        return <Option key={item.value} value={item.value}>{item.key}</Option>
                                    })
                                }
                            </Select>
                        </Col>
                        <Col span={2} style={{ lineHeight: 2.2,marginLeft: 10 }}>
                        {
                            this.props.btnLists.indexOf('btn_teii_intersection_timing_create') >=0 ? (
                                <>
                                    <Button 
                                        title={MODULENAME}
                                        type='link'
                                        icon={<PlusOutlined/>}
                                        onClick={() =>{
                                            this.create();
                                        }}>
                                    </Button>
                                    <Upload
                                        action={CNF.api + 'intersection/timings'}
                                        headers={AddRequestHeaders()}
                                        onChange={this.upload}
                                        beforeUpload={this.uploadCheck}
                                        showUploadList={false}
                                        name='file'
                                        accept='xlsx,xls'
                                    >
                                        <Button
                                            title={MODULENAME}
                                            type='link'
                                            icon={<ImportOutlined/>}
                                        >
                                        </Button>
                                    </Upload>
                                </>):''
                        }
                        {
                            this.props.btnLists.indexOf('btn_teii_intersection_timing_export') >=0 ? (
                                <Button
                                    title={MODULENAME}
                                    type='link'
                                    icon={<ExportOutlined/>}
                                    onClick={(e) =>{
                                        this.exportObtain(e);
                                    }}>
                                </Button>
                            ):''
                        }
                        </Col>
                        <Entity 
                            policy={this.props.policy}
                            isModalOpen={this.state.isModalOpen} 
                            record={this.state.record}
                            setIsModalOpen={this.setIsModalOpen} 
                            isRefresh={this.isRefresh}
                            intersectionDDList={this.state.intersectionDDList}
                        />
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Lists 
                                preGroup={this.props.preGroup}
                                btnLists={this.props.btnLists}
                                dataLists={this.state.dataLists} 
                                currentIndex={this.state.currentIndex}
                                pageCount={this.state.pageCount} 
                                changeIndex={this.changeIndex} 
                                setIsModalOpen={this.setIsModalOpen}
                                isRefresh={this.isRefresh}
                            />
                        </Col>
                    </Row>
                </div>
                <div id='timing-archive-id'></div>
                <div id='info-prompt-modal-id'></div>
            </>
        );
    }
}

export default CPT